<template>
  <v-btn
    v-if="instructionsEnabled"
    large
    class="i-btn-instructions g-full-width"
    :loading="fetching"
    :disabled="fetching"
    @click="handleShowInstructions"
  >
    Instructions
  </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {},

  props: {
    instructionKey: {
      type: String,
      required: true
    },
    instructionSection: {
      type: String,
      required: false,
      default: null
    },
    disregardSections: {
      type: Array,
      required: false,
      default: null
    }
  },

  data: () => ({}),

  computed: {
    ...mapGetters('tenant', ['instructionsEnabled']),
    ...mapState('instructions', ['fetching', 'show'])
  },

  methods: {
    ...mapActions('instructions', ['showInstructions']),

    handleShowInstructions() {
      const instruction = {
        instructionKey: this.instructionKey,
        instructionSection: this.instructionSection,
        filteredSections: this.disregardSections
      }
      this.showInstructions(instruction)
      this.$emit('open')
    }
  },

  mounted() {},

  watch: {
    instructionSection() {
      if (this.show) this.handleShowInstructions()
    }
  }
}
</script>
